/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authstartsending2Inputs */

const en_authstartsending2 = /** @type {(inputs: Authstartsending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending…`)
};

const pt_authstartsending2 = /** @type {(inputs: Authstartsending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A enviar…`)
};

/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {Authstartsending2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authstartsending2 = /** @type {((inputs?: Authstartsending2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authstartsending2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authstartsending2(inputs)
	return pt_authstartsending2(inputs)
});
export { authstartsending2 as "authStartSending" }